// src/config/appConfig.ts
export type Environment = "local" | "development" | "production";

export interface AppConfig {
    environment: Environment;
    baseApiUrl: string;
    webSocketUrl: string;
    agentApiUrl: string;
    filePath: string;
    filePdfPath: string;
    fileUrl: string;
    googleMapsApiKey: string;
    passengerInfoBaseUrl: string;
}

const ENV = (process.env.REACT_APP_NODE_ENV as Environment) || "development";

const configs: Record<Environment, AppConfig> = {
    development: {
        environment: "development",
        baseApiUrl: "https://dev.zupp.in",
        webSocketUrl: "ws://127.0.0.1:9999",
        agentApiUrl: "https://agent-test.zupp.in",
        filePath: "/busbank/images///",
        filePdfPath: "/busbank/pdf/",
        fileUrl: "https://dev.zupp.in",
        googleMapsApiKey: "AIzaSyDhBc5u46ZxVaTICVN5-nWQH6a8pfk2qm8",
        passengerInfoBaseUrl: "https://webdev.zupp.in"
    },
    local: {
        environment: "local",
        baseApiUrl: "http://127.0.0.1:9991",
        webSocketUrl: "ws://127.0.0.1:9999",
        agentApiUrl: "http://127.0.0.1:11111",
        filePath: "/busbank/images///",
        filePdfPath: "/busbank/pdf/",
        fileUrl: "https://dev.zupp.in", // sen böyle vermiştin, aynen bıraktım
        googleMapsApiKey: "AIzaSyDhBc5u46ZxVaTICVN5-nWQH6a8pfk2qm8",
        passengerInfoBaseUrl: "http://localhost:3000"
    },
    production: {
        environment: "production",
        baseApiUrl: "https://api.zupp.in",
        webSocketUrl: "ws://api.zupp.in:9999",
        agentApiUrl: "https://agent.zupp.in",
        filePath: "/busbank/images///",
        filePdfPath: "/busbank/pdf/",
        fileUrl: "https://api.zupp.in",
        googleMapsApiKey: "AIzaSyDhBc5u46ZxVaTICVN5-nWQH6a8pfk2qm8",
        passengerInfoBaseUrl: "https://zupp.in"
    }
};

const appConfig = configs[ENV];

export default appConfig;
